import * as yup from "yup";

export const infoBarDataSchema = yup.object({
  shippingData: yup
    .object({
      header: yup.string().required("Title is required"),
      description: yup.string().required("Description is required"),
      content: yup.string().required("Content is required")
    })
    .required("Shipping Data is required"),
  returnsData: yup
    .object({
      header: yup.string().required("Header is required"),
      description: yup.string().required("Description is required"),
      content: yup.string().required("Content is required")
    })
    .required()
});
